// 初始化
// const initTabValue =
function initTabValue2(){

  // if(window.sessionStorage.getItem('tabsValue')!= null){
  //
  //   const aa=JSON.parse(window.sessionStorage.getItem('tabsValue'));
  //   console.log('原始>>>',window.sessionStorage.getItem('tabsValue'))
  //   console.log('aa>>>',aa)
  //   const bb=JSON.stringify(aa);
  //   console.log(aa.activePath,bb);
  //   const cc=JSON.parse(bb);
  //   console.log(cc.activePath,cc)
  // }



  // console.log('2222>>>',window.sessionStorage.getItem('tabsValue'))

  const  tv=null!=window.sessionStorage.getItem('tabsValue')? JSON.parse(window.sessionStorage.getItem('tabsValue')): {
    tabsValue: [],
    activePath:'',//当前选中的index
  };

  window.sessionStorage.removeItem('tabsValue');
  return tv;
}

const tabsValue={
  // namespaced:true,
  state:initTabValue2(),
  getters: {
    tabsValue: state => state.tabsValue,
    activePath:state=>state.activePath
  },
  mutations: {
    /**
     * 删除标签
     * @param state
     * @param data
     */
    delTab(state, targetPath) {//设置导航信息

      let tabs = state.tabsValue;
      let activePath = state.activePath;
      if (activePath === targetPath) {
        tabs.forEach((tab, index) => {
          // console.log('删除tab:::',tab)
          if (tab.path === targetPath) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activePath = nextTab.path;
            }
          }
        });
      }

      state.activePath = activePath;

      state.tabsValue = tabs.filter(item => item.path !== targetPath)
    },
    /**
     * 添加标签
     * @param state
     * @param data
     */
    addTab(state, data){
      // 判断是否已经存在
      const isExist = state.tabsValue.some(item => item.path === data.path)
      // 如果不存在添加
      if (!isExist) {
        state.tabsValue.push(data)
        // state.activePath=data.path;
      }
      state.activePath=data.path;

    },
    /**
     * 初始化数据，在注销时调用，不然切换用户后还是旧标签数据
     * @param state
     */
    resetTabsValue(state,data){
      // console.log('调用重置Tabs方法',initTabValue2(),window.sessionStorage.getItem("tabsValue"))
      window.sessionStorage.removeItem('tabsValue');
      // const tabv=initTabValue2();
      const tabv=data||initTabValue2();
      state.activePath=tabv.activePath;
      state.tabsValue=tabv.tabsValue;
      // console.log('结束',state)

    },
    /**
     * 设置当前活动路径
     * @param state
     * @param data
     */
    setActivePath(state, data){
      state.activePath=data;
    }
  },
  actions: {// 管理mutations
    DEL_TAB(context, data) {//添加导航信息
      // console.log('放入数据了：：',data)
      context.commit('delTab', data);
    },
    ADD_TAB(context, data){
      context.commit('addTab', data);
    },
    SET_ACTIVEPATH(context, data){
      context.commit('setActivePath', data);
    },
    RESET_TAB(context, data){
      context.commit('resetTabsValue',data);
    }
  }
}
export default tabsValue;



// WEBPACK FOOTER //
// ./src/store/tabsValue.js